var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMoMenuM04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 42,
    viewBox: "0 0 57 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9107 2.1229C51.9107 1.5053 51.4054 1 50.7878 1H5.94687C5.32928 1 4.82397 1.5053 4.82397 2.1229V39.7773H51.9107V2.1229Z",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2415 37.4443V38.0058C32.2415 38.5236 31.68 38.9415 30.9938 38.9415H25.7474C25.0549 38.9415 24.4997 38.5236 24.4997 38.0058V37.4443H1V38.1929C1 39.7463 2.67811 41.0002 4.74922 41.0002H51.992C54.0631 41.0002 55.7412 39.74 55.7412 38.1929V37.4443H32.2415Z",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1175 10.0823H11.5679V32.1472H45.1175V10.0823Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1175 6.44556H11.5679V10.0763H45.1175V6.44556Z",
    fill: "white",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2853 20.9132C35.2853 24.8371 32.11 28.0124 28.1861 28.0124C24.2622 28.0124 21.0869 24.8371 21.0869 20.9132C21.0869 16.9893 24.2622 13.814 28.1861 13.814C32.11 13.814 35.2853 16.9893 35.2853 20.9132Z",
    fill: "white",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoMenuM04);
export default __webpack_public_path__ + "static/media/ic_mo_menu_m04.b8aec2c5ed42ebc86547d1f479c79c51.svg";
export { ForwardRef as ReactComponent };